import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=1f040711&scoped=true&"
import script from "./Cgu.vue?vue&type=script&lang=ts&"
export * from "./Cgu.vue?vue&type=script&lang=ts&"
import style0 from "./Cgu.vue?vue&type=style&index=0&id=1f040711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f040711",
  null
  
)

export default component.exports